export { Template as EstatePlanningRecommendationBasicInformationStepTemplate } from './Template';
